import { render, staticRenderFns } from "./ChatList.vue?vue&type=template&id=4177fdaa&scoped=true"
import script from "./ChatList.vue?vue&type=script&lang=js"
export * from "./ChatList.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/chat.css?vue&type=style&index=0&id=4177fdaa&prod&scoped=true&lang=css&external"
import style1 from "./ChatList.vue?vue&type=style&index=1&id=4177fdaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4177fdaa",
  null
  
)

export default component.exports